const getTokenLogoURL = (address: string) => `/images/tokens/${address}.png`

export default getTokenLogoURL
